import { AbstractControl } from '@angular/forms';

export function noWhitespaceValidator(control: AbstractControl) {
  const isWhitespace = control.value ? control.value.trim().length === 0 : false;

  return isWhitespace ? { 'noWhitespace': true } : null;
}
